import request from '@/utils/request'
import URL from '@/api/urlTranslator'

// 查询保单管理
export function getQueryConfig(data) {
  return request({
    url: URL.external.insurance.query,
    method: 'post',
    data
  })
}

// 填写保单信息
export function getInsureInfoConfig(data) {
  return request({
    url: URL.external.insurance.fillInsuranceInfo,
    method: 'post',
    data
  })
}

// 填写保单信息
export function getInsureByUuid(uuid, isReIssue) {
  return request({
    url: URL.external.insurance.getInsureByUuid,
    method: 'get',
    params: { uuid, isReIssue }
  })
}

// 暂存
export function getSaveInsureConfig(data) {
  return request({
    url: URL.external.insurance.saveInsure,
    method: 'post',
    data
  })
}

// 修改
export function getUpdateInsureConfig(uuid) {
  return request({
    url: URL.external.insurance.updateInsure,
    method: 'post',
    params: { uuid }
  })
}

// 询价
export function getQueryPriceConfig(data) {
  return request({
    url: URL.external.insurance.queryPrice,
    method: 'post',
    data
  })
}

// 投保
export function getDoInsureConfig(data) {
  return request({
    url: URL.external.insurance.doInsure,
    method: 'post',
    data
  })
}

// 注销保单
export function getCancelInsureConfig(data) {
  return request({
    url: URL.external.insurance.cancelInsure,
    method: 'put',
    params: data
  })
}

// 删除保单
export function getDeteleInsure(data) {
  return request({
    url: URL.external.insurance.deteleInsure,
    method: 'post',
    data
  })
}

export function getQueryInvoiceCurrencyConfig() {
  return request({
    url: URL.external.insurance.queryInvoiceCurrency,
    method: 'get'
  })
}

export function getQueryClaimAgentConfig() {
  return request({
    url: URL.external.insurance.queryClaimAgent,
    method: 'get'
  })
}

export function getQueryGoodsCategoryConfig() {
  return request({
    url: URL.external.insurance.queryGoodsCategory,
    method: 'get'
  })
}

export function queryEmailReceivers(data) {
  return request({
    url: URL.external.insurance.queryEmailReceivers,
    method: 'get',
    params: data
  })
}

// 判断是否已投保成功
export function queryIsInsured(jobUuid, cargoDocUuid) {
  return request({
    url: URL.external.insurance.judgeIsInsured,
    method: 'get',
    params: { jobUuid, cargoDocUuid }
  })
}
